<template>

  <v-card class="mb-3">
    <v-card-title>
      <span class="headline">Update Merchant Purchase Notification URL</span>
    </v-card-title>

    <m-pay-confirm-dialog
      :show="showConfirmationDialog"
      title="Are you sure you want to update Merchant Purchase Notification URL?"
      @yes="update"
      @cancel="showConfirmationDialog = false"
      maxWidth="700px"
    />

    <m-pay-generic-editor
      :bean="merchant"
      :beanProperties="editableMerchantProperties"
      :beanLabels="labels"
      :validationRules="validationRules"
      :loading="loading"
      submitButtonColor="red"
      @submit="confirmUpdate"
      @change="setCurrentCallback"
    >
      <template slot="submitButton">
        Update
        <v-icon right dark>edit</v-icon>
      </template>
      <template slot="firstActions">
        <v-btn flat
               color="primary"
               :loading="loading"
               :disabled="loading"
               @click.native="pingCallback">
          Ping
          <v-icon right dark>send</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <span slot="activator">
            <v-icon color="primary" small class="ml-1">help</v-icon>
          </span>
          <span>
            Sending HTTP OPTIONS request.<br/>
            Expecting HTTP status 200.<br/>
            Expecting HTTP Response Header 'Access-Control-Allow-Methods' to contain
            'PUT' value.<br/>
          </span>
        </v-tooltip>
      </template>
      <template slot="description">
        <div class="mb-4 subheading">
          URL will be accessed from public IP:<br/>{{ publicIp }}
          <m-pay-copy-button :value="publicIp"></m-pay-copy-button>
        </div>
      </template>
    </m-pay-generic-editor>
  </v-card>

</template>

<script>
import MPayGenericEditor from '../MPayGenericEditor';
import MPayConfirmDialog from '../MPayConfirmDialog';
import MPayCopyButton from '../MPayCopyButton';

export default {
  name: 'MPayMerchantPaymentNotificationUrlEditor',
  props: {
    merchant: { required: true },
    loading: { required: true },
    publicIp: { required: true },
  },
  components: { MPayGenericEditor, MPayConfirmDialog, MPayCopyButton },
  data: () => ({
    showConfirmationDialog: false,
    editableMerchantProperties: [
      'purchaseNotificationUrl',
    ],
    labels: [
      'Purchase Notification URL',
    ],
    validationRules: [
      'required|url',
    ],
    confirmedMerchant: {},
    userInputCallbackUrl: '',
  }),
  methods: {
    confirmUpdate(merchant) {
      this.showConfirmationDialog = true;
      this.confirmedMerchant = merchant;
    },
    update() {
      this.showConfirmationDialog = false;
      this.$emit('submit', this.confirmedMerchant);
    },
    setCurrentCallback(model) {
      this.userInputCallbackUrl = model.purchaseNotificationUrl;
    },
    pingCallback() {
      this.$emit('ping', { purchaseNotificationUrl: this.userInputCallbackUrl });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantPaymentNotificationUrlEditor.vue